import { makeRequest } from 'features/entry-form-v2/data/makeRequest';

export type GetFileUploadUrlForSurveyResponse = {
	fileId: string;
	url: string;
	fields: Record<string, string>;
};

export const getFileUploadUrlForSurvey = async ({
	surveyId,
	pinCode,
	entryId,
	fileName,
	fileVariableName
}: {
	surveyId: string;
	pinCode: string;
	entryId: string;
	fileName: string;
	fileVariableName: string;
}) => {
	return makeRequest<GetFileUploadUrlForSurveyResponse>({
		method: 'getFileUploadUrlForSurvey',
		service: 'cde',
		validateCredentials: false,
		data: {
			surveyId,
			pinCode,
			entryId,
			fileName,
			fileVariableName
		}
	});
};
